import { createPremiumModule, ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
import { SiteLevelDomainsResultsPage } from '../Pages/SiteLevelGate/ResultsPage/SiteLevelDomainsResultsPage';
import { DOMAINS_SEARCH_GATE_TRANSLATIONS_NS, resourceLoader } from '../assets/resourceLoader';
import { DomainsSearchGateBMExtension } from './extensions/DomainsSearchGateBM';
import { DomainSearchGateBiExtension } from './extensions/DomainSearchGateBiExtension/DomainSearchGateBiExtension';
import { InsightsModalExtension } from './extensions/AiInsightsModalExtension';
import { ModalsProvider } from './ModalsProvider';
import { SiteLevelGateHomePage } from '../Pages/SiteLevelGate/HomePage';
import { SiteSearchGatePages, HarmonySiteSearchGate } from '../Pages';
import { AccountLevelGatePages } from '../Pages/AccountGate';
import { LoggedInMobileGatePages } from '../Pages/LoggedInMobileGate';
import { TldListResultsPage } from '../Pages/TldListGate';
import { AnonymousResultsPage, AnonymousGatePages, WhoisResultsPage } from '../Pages/AnonymousGate';
import { EmbeddedGatePages } from '../Pages/EmbeddedGate';
import { BngResultsGatePages } from '../Pages/BngResultsGatePages';
import { FunnelGatePages } from '../Pages/FunnelGate';
import { AnonymousBusinessEmailResultsPage, AnonymousBusinessEmailGatePages } from '../Pages/AnonymousBusinessEmailGatePages';
export const DomainSearchGateModule = createPremiumModule('domainSearchGate', [ModuleExtensions.translationsExtension(resourceLoader, {
  namespace: DOMAINS_SEARCH_GATE_TRANSLATIONS_NS
}), DomainsSearchGateBMExtension, DomainSearchGateBiExtension, InsightsModalExtension], () => ({
  SDK: {
    Components: {
      ModalsProvider
    },
    Pages: {
      SiteSearchGatePages,
      HarmonySiteSearchGate,
      AccountLevelGatePages,
      LoggedInMobileGatePages,
      AnonymousGatePages,
      AnonymousResultsPage,
      FunnelGatePages,
      EmbeddedGatePages,
      BngResultsGatePages,
      AnonymousBusinessEmailGatePages,
      AnonymousBusinessEmailResultsPage,
      SiteLevelGateHomePage,
      SiteLevelDomainsResultsPage,
      WhoisResultsPage,
      TldListResultsPage
    }
  }
}));
//# sourceMappingURL=domainSearchGate.module.js.map